import axios from 'axios';

export const GET_ADDITIONAL_PAYMENT_SUBMISSIONS_BEGIN = 'GET_ADDITIONAL_PAYMENT_SUBMISSIONS_BEGIN';
export const GET_ADDITIONAL_PAYMENT_SUBMISSIONS_SUCCESS = 'GET_ADDITIONAL_PAYMENT_SUBMISSIONS_SUCCESS';
export const GET_ADDITIONAL_PAYMENT_SUBMISSIONS_FAILURE = 'GET_ADDITIONAL_PAYMENT_SUBMISSIONS_FAILURE';
export const GET_ADDITIONAL_PAYMENT_SUBMISSIONS_RESET = 'GET_ADDITIONAL_PAYMENT_SUBMISSIONS_RESET';

export const getAdditionalPaymentSubmissionsBegin = () => ({
    type: GET_ADDITIONAL_PAYMENT_SUBMISSIONS_BEGIN
});

export const getAdditionalPaymentSubmissionsSuccess = (data) => ({
    type: GET_ADDITIONAL_PAYMENT_SUBMISSIONS_SUCCESS,
    payload: data
});

export const getAdditionalPaymentSubmissionsFailure = (error) => ({
    type: GET_ADDITIONAL_PAYMENT_SUBMISSIONS_FAILURE,
    payload: error
});

export const getAdditionalPaymentSubmissionsReset = () => ({
    type: GET_ADDITIONAL_PAYMENT_SUBMISSIONS_RESET
});

export const getAdditionalPaymentSubmissions = (webappurlForms, accessToken, organisationId, organisationArn) => {
    return dispatch => {
        const options = {
            headers: {
                'Authorization': "Bearer " + accessToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        const data = {
            organisationId: organisationId,
            organisationArn: organisationArn
        };
       
        dispatch(getAdditionalPaymentSubmissionsBegin());
        return axios.post(webappurlForms + `/api/myCASA/Forms/Query/Crm/Submission/AdditionalPayment/v1`, data, options)
            .then(response => {
                if (response.data.wasSuccessful && response.data.submissions.length > 0) {
                    return dispatch(getAdditionalPaymentSubmissionsSuccess(response.data.submissions));
                }
                else {
                    return dispatch(getAdditionalPaymentSubmissionsFailure(response.data.error));
                }
            })
            .catch(error => {
                return dispatch(getAdditionalPaymentSubmissionsFailure(error.response?.data.errors ?? error.message));
            });
    };
}
